import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: { isOpen: false },
};

const loginSlice = createSlice({
  name: "loginmodal",
  initialState,
  reducers: {
    loginModalOpen: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { loginModalOpen } = loginSlice?.actions;
export default loginSlice?.reducer;
